/* eslint-disable jsx-a11y/img-redundant-alt */
import { Box } from '@mui/material';

import logo from 'assets/images/logo.png';

const SplashScreen = () => {
  return (
    <Box className="splash-screen">
      <img src={logo} alt="Logo image" />
      <Box className="spinner">
        <Box className="bounce-1"></Box>
        <Box className="bounce-2"></Box>
        <Box className="bounce-3"></Box>
      </Box>
    </Box>
  );
};

export default SplashScreen;
